import {useNavigate} from 'react-router-dom';

import {Button} from '@components/ui/Button';

export const NotFound = () => {
  const navigate = useNavigate();
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-background text-center">
      <p className="text-6xl font-extrabold tracking-tight text-foreground">404</p>
      <p className="text-muted-foreground">Страница не найдена</p>
      <Button onClick={() => navigate('/dashboard')}>На дашборд</Button>
    </div>
  );
};
